export const SCHEDULING_MODE = {
  MINUTE: 'minute',
  HOURLY: 'hour',
  DAILY: 'day',
  WEEKLY: 'week',
}

export const BIN_MODE = {
  NONE: 'None',
  EQUAL: 'Equal',
  QUANTILE: 'Quantile',
  PROVIDED: 'Provided',
}

export const AGGREGATION_MODE = {
  EDGES: 'Edges',
  DENSITY: 'Density',
  CUMULATIVE: 'Cumulative',
}

export const AGGREGATION_TYPE = {
  UNIVARIATE: 'UnivariateContinuous',
}

export const METRIC_TYPE = {
  MAXDIFF: 'MaxDiff',
  SUMDIFF: 'SumDiff',
  PSI: 'PSI',
}

export const MONITORING_PATH = {
  INPUT: 'input 0 0',
  OUTPUT: 'output 0 0',
}

export const ASSAY_RUN_STATUS = {
  OK: 'Ok',
  WARNING: 'Warning',
  ALERT: 'Alert',
  BASELINE_RUN: 'BaselineRun'
}
